import create from 'zustand';

import { Nullable } from '~types/common';

interface AdminStore {
  jwt: Nullable<string>;
  setJwt: (jwt: Nullable<string>) => void;
  isAdmin: boolean;
  setIsAdmin: (isAdmin: boolean) => void;
}

const useAdminStore = create<AdminStore>((set) => ({
  jwt: null,
  setJwt: (jwt) => set(() => ({ jwt })),
  isAdmin: false,
  setIsAdmin: (isAdmin) => set(() => ({ isAdmin })),
}));

export default useAdminStore;
